import React, { Component } from "react";
import Pagination from "../../../Components/Pagination";
import Btn from "../../../Components/Btn";
import BookingPopup from "./BookingPopup";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import scrollToComponent from "react-scroll-to-component";
import { 
  cardStatuses,
  getStatus, 
  getType,
  getPaymentMethod
} from "../../../config";
import { setPerPage, setPage, search } from "../../../store/search/actions";
import { shouldUnhighlightTicket } from "../../../store/tickets/actions";
import Display from "../../../Components/Display";
import { formatDate } from "../../../helpers/formatters";
import RatingStars from "../../../helpers/RatingStars.jsx";
import DashboardApi from "../../../api/DashboardApi"
import { Snackbar, CircularProgress } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
//import { getRatingAverage } from '../BookingsHelper';

class BookingsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupActive: null
    };
  }

  togglePopupClasses = (event, id) => {
    event.preventDefault();
    this.setState({ popupActive: this.state.popupActive !== id ? id : null });
  };

  setPerPage = e => {
    this.props.setPerPage(e.target.value);
  };

  setPage = id => {
    const table = document.querySelector(".booking-table-card");

    scrollToComponent(table, {
      align: "top"
    });

    console.log({ id });

    this.props.setPage(id);
  };

  shouldUnhighlight = CardID => {
    this.props.shouldUnhighlightTicket(CardID);
  };
  shouldHighlight = CardID => {
    if (!this.props.tickets.highlighted_tickets.length) return false;
    return this.props.tickets.highlighted_tickets.includes(CardID);
  };
  render() {
    const tickets = this.props.tickets.tickets;
    console.log('Booking 1:', tickets[0]);
    return (
      <div className="booking-table-card">
        <div className="header-div">
          <Pagination
            currentPage={this.props.current_page}
            totalPages={this.props.total_pages}
            selectPage={this.props.setPage}
          />
          <Display
            label="Display"
            onChange={this.setPerPage}
            options={[100, 200, 300]}
          />
        </div>
        
        <div className="table-responsive">
          <table className="basic-table">
            <thead>
              <tr>
                {this.props.debug && <th>ID</th>}
                <th>Booking ID.</th>
                <th>Booking Date</th>
                <th>Booking Type</th>
                <th>Pax</th>
                <th>Traveler Name</th>
                <th>Contacts</th>
                <th>Route</th>
                <th>Payment Method</th>
                <th>Price / Class</th>
                <th>Average Rating</th>
                <th>Confirmation Email</th>
                <th />
              </tr>
            </thead>
            <tbody> 
              {tickets.map((booking, i) => (
                <TicketRow
                  key={booking.CardID}
                  booking={booking}
                  shouldUnhighlight={this.shouldUnhighlight}
                  shouldHighlight={this.shouldHighlight}
                  togglePopupClasses={this.togglePopupClasses}
                  debug={this.props.debug}
                  i={i}
                />
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          currentPage={this.props.current_page}
          totalPages={this.props.total_pages}
          selectPage={this.props.setPage}
          updatedPage={this.props.current_page - 1}
        />
        <BookingPopup
          currentBooking={this.state.popupActive}
          toggleFn={this.togglePopupClasses}
        />
      </div>
    );
  }
}

class TicketRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
        loadingAlert: false,
        alertMsg: "",
        autoHide: null,
        snackAction: null
    };
}
  /**
   * Calculate trip average rating [TODO] - check rating length
   * @param {*} rating
   * Aya Solaiman 
   */

  getRatingAverage (rating, myTrips){
    if(rating && !Array.isArray(rating)){
      console.log("Rating Object");
      let bus = rating.bus.cleanliness;
      let driver = rating.driver.performance;
      //console.log('bus:',bus,' driver:',driver);
      //console.log('Avrage:', (bus + driver)/2);
      const average = ((bus + driver)/2)
      return (
        <div className="flex">
          <span>Leg 1:</span>
          <RatingStars
            filled = {average}
          />
        </div>
      );
    }
    if(rating && Array.isArray(rating)){
      console.log('rating round:',rating);
      //console.log('rating round:',myTrips);
      console.log('#trips', myTrips.length, '#ratings', rating.length);
      //trip1 : rate1 || trip2 : rate1 || trip1 : rate1 && trip2 : rate2
      let leg1, leg2, avrge1, avrge2;
      //One trip, one rating
      if(myTrips.length === 1){
        leg1 = {
          trip_sub_Id: rating[0].trip_sub_Id,
          bus: rating[0].bus.cleanliness,
          driver: rating[0].driver.performance
        }
        avrge1 = ((leg1.bus + leg1.driver)/2);
        return(
          <div className="flex">
            <span>Leg 1:</span>
            <RatingStars
              filled = {avrge1}
            />
          </div>
        );
      }
      //myTrips: [{},{}] && rating: [{}]
      if(myTrips.length > 1 && rating.length >= 1){
        console.log('check leg 2');
          myTrips.forEach(trip => {
            rating.forEach(rate => {
              if(myTrips.indexOf(trip) === 0 && Number(rate.trip_sub_Id) === trip.TripSubData_Id){
                leg1 = {
                  trip_sub_Id: rate.trip_sub_Id,
                  bus: rate.bus.cleanliness,
                  driver: rate.driver.performance
                }
                avrge1 = ((leg1.bus + leg1.driver)/2);
                console.log('Leg 1:', avrge1);
              }
              if(myTrips.indexOf(trip) === 1 && Number(rate.trip_sub_Id) === trip.TripSubData_Id){
                leg2 = {
                  trip_sub_Id: rate.trip_sub_Id,
                  bus: rate.bus.cleanliness,
                  driver: rate.driver.performance
                }
                avrge2 = ((leg2.bus + leg2.driver)/2);
                console.log('Leg 2:', avrge2);
              }
            })
          })
        if(leg1 && leg2){
          return(
            <>
            <div className="flex">
              <span>Leg 1:</span>
              <RatingStars
                filled = {avrge1}
              />
            </div>
            <div className="flex">
              <span>Leg 2:</span>
              <RatingStars
                filled = {avrge2}
              />
            </div>  
            </>
          );
        }else
        if(leg1 && !leg2){
          return(
            <div className="flex">
              <span>Leg 1:</span>
              <RatingStars
                filled = {avrge1}
              />
            </div>
          );
        }else{
          return(
            <div className="flex">
              <span>Leg 2:</span>
              <RatingStars
                filled = {avrge2}
              />
            </div>
          );
        }
      }
      //myTrips: [{1},{2}] && rating: [{1},{2}]
      return "Round Rate";
    } 
    if(!rating){
      //console.log('Not rated yet!');
      return "N/A";
    }   
  }

  /**
   * send request to back-end for re-sending confirmation email
   */
  sendConfirmEmail = async () => {
    const booking = this.props.booking;
    const userEmail = booking.UserEmail;
    const ticketID = booking.CardID;
    console.log('[CONFIRM] Email sent to:', userEmail);

    //Popup: confirm sending the email with user
    const confirmEmail = window.prompt("Are you sure? Send to this email.\nYou can send to another email!",userEmail);
    if(!confirmEmail){
      //alert('Sending email is canceled!');
      return false;
    }
    //Send request
    try{
      document.getElementById('emailBtn').disabled = true;
      this.setState(prev => ({...prev, loadingAlert: true, alertMsg:"Sending email...Please Wait!", snackAction:<CircularProgress />}));
      const sendResult = await DashboardApi.sendEmail(confirmEmail, ticketID, "paid-ticket");
      if(sendResult.success){
        this.setState(prev => ({...prev, alertMsg:"Success",loadingAlert: true, snackAction: null, autoHide:2000}));
        document.getElementById('emailBtn').disabled = false;
      }else{
        alert('Failed to Resend Confirmation Email!');
        console.error("[CONFIRM-EMAIL] send result error: ", sendResult);
      }
    }catch(err){
      console.log("[CONFIRM-EMAIL] catch error: ", err.message);
    }
   
  }
  
  render() {
    const {
      booking,
      shouldHighlight,
      shouldUnhighlight,
      togglePopupClasses,
      debug,
      i
    } = this.props;
    const {loadingAlert, alertMsg, autoHide, snackAction} = this.state;
    return (
      <>
      <Snackbar 
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        message = {alertMsg}
        open={loadingAlert}
        autoHideDuration={autoHide}
        action={snackAction}
        onClose = {
          (event, reason) => {
            if (reason === 'clickaway') {
              return;
            }
            this.setState(prev => ({...prev, alertMsg:"",loadingAlert: false, snackAction: null, autoHide:null}));
          }
        }
      >
        {alertMsg === 'Success' && (
           <Alert severity="success" variant="filled">Email Sent Successfully!</Alert>
        )}
      </Snackbar>
      <tr
        key={booking.CardID}
        onMouseEnter={() => shouldUnhighlight(String(booking.CardID))}
        className={
          shouldHighlight(String(booking.CardID))
            ? "bgc__fade highlight"
            : "bgc__fade"
        }
      >
        {debug && <td>{i + 1}</td>}
        <td>
          {booking.CardID}
          <br />
          <span className={`booking-status ${getStatus(booking.CardStatusID)}`}>
            {getStatus(booking.CardStatusID)}
          </span>
        </td>
        <td>{formatDate(booking.ActionDate)}</td>
        <td>{getType(booking.myTrips.length)}</td>
        <td>{booking.myTrips[0].TripSeatsCount}</td>
        <td>
          <div className="minW100">
            {unescape(booking.name || booking.UserName)}
          </div>
        </td>
        <td>
          {booking.UserEmail}
          <br />
          {booking.phone || booking.UserTelNo}
        </td>
        <td>
          <div className="minW100">
            {booking.myTrips[0].TripOfficeFrom} -{" "}
            {booking.myTrips[0].TripOfficeTo}
          </div>
        </td>
        <td>
          {booking.PaymentMethod}
        </td>
        <td>
          <div className="nowrap">
            <strong>{booking.CardTotalPrice} EGP</strong>
            <br />
            {booking.myTrips[0].TripServKind}
          </div>
        </td>
        <td>
          <div className="nowrap">
          { this.getRatingAverage(booking.rating, booking.myTrips) }
          </div>
        </td>
        <td>
          {booking.CardStatusID === cardStatuses.paid && (
            <Btn
              id="emailBtn"
              className="btn simple"
              onClick={this.sendConfirmEmail}
              >
              Resend
            </Btn>
          )}
        </td>
        <td>
          <Btn
            className="btn simple"
            onClick={event => togglePopupClasses(event, booking.CardID)}
          >
            View
          </Btn>
        </td>
      </tr>
      </>
    );
  }
}

const mapStateToProps = state => ({
  tickets: state.tickets,
  // highlightedTickets: state.tickets.highlighted_tickets,
  current_page: state.search.paginationOptions.page,
  total_pages: state.tickets.total_pages,
  loading_search: state.search.loading_search,
  debug: state.app.debug
});

const mapDispatchToProps = dispatch => ({
  setPage: bindActionCreators(setPage, dispatch),
  search: bindActionCreators(search, dispatch),
  setPerPage: bindActionCreators(setPerPage, dispatch),
  shouldUnhighlightTicket: bindActionCreators(shouldUnhighlightTicket, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingsTable);
